import jrpc20WSClient from "./jrpc20WSClient";
import employee from "./employee";

class warehouse {
    wsClient = new jrpc20WSClient(process.env.REACT_APP_BACKEND_WS_URL, process.env.REACT_APP_BACKEND_WS_USR, process.env.REACT_APP_BACKEND_WS_PWD)

    getProducts() {
        let employee_obj = new employee();
        return new Promise((resolve, reject) => {
            let post_data = {
                user_data: {
                    token: employee_obj.token
                },
                call_data: {}
            };

            this.wsClient.request('post', 'warehouse/finishedProducts/wsGetProducts', post_data).then((result) => {
                resolve(result.call_data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    getDetailVersamenti(data) {
        let employee_obj = new employee();
        return new Promise((resolve, reject) => {
            let post_data = {
                user_data: {
                    token: employee_obj.token
                },
                call_data: {
                    order_uuid: data.order_uuid
                }
            };

            this.wsClient.request('post', 'warehouse/finishedProducts/wsGetDetailVersamenti', post_data).then((result) => {
                resolve(result.call_data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    getDischargeHistory(data) {
        let employee_obj = new employee();
        return new Promise((resolve, reject) => {
            let post_data = {
                user_data: {
                    token: employee_obj.token
                },
                call_data: {
                    order_uuid: data.order_uuid
                }
            };

            this.wsClient.request('post', 'warehouse/finishedProducts/wsGetDischargeHistory', post_data).then((result) => {
                resolve(result.call_data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    getAllDischargeHistory() {
        let employee_obj = new employee();
        return new Promise((resolve, reject) => {
            let post_data = {
                user_data: {
                    token: employee_obj.token
                },
                call_data: {}
            };

            this.wsClient.request('post', 'warehouse/finishedProducts/wsGetAllDischargeHistory', post_data).then((result) => {
                resolve(result.call_data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    saveScarico(data) {
        let employee_obj = new employee();
        return new Promise((resolve, reject) => {
            let post_data = {
                user_data: {
                    token: employee_obj.token
                },
                call_data: {
                    discharge_date: data.discharge_date,
                    employee_uuid: data.employee_uuid,
                    ddt_number: data.ddt_number,
                    items: data.items
                }
            };

            this.wsClient.request('post', 'warehouse/finishedProducts/wsSaveScarico', post_data).then((result) => {
                resolve(result.call_data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
}

export default warehouse;
